import React, { FC, memo, useEffect } from 'react'

import { useSetFocus } from '@please/lrud'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/Button/Button'
import { LoginHeader } from '@/components/LoginHeader'
import { QrCode } from '@/components/QrCode/QrCode'
import { qrCodeUrl, qrSize } from '@/constants/common'
import { focusIds, orientation } from '@/constants/focus'
import { icons } from '@/constants/icons'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { closeApp } from '@/platform/platform'

import {
  LogoutWrapper,
  MobileAppDescription,
  MobileApp,
  MobileAppImg,
  TextElem,
  MobileAppImgWrapper,
  Row,
  ContentWrapper,
  ButtonBox,
  ContentBox,
  ImportantBodyText,
  StoreImg,
} from './styles'

const focusId = `${focusIds.EXIT}${focusIds.CONTAINER_MOD}`

const ExitScreenRaw: FC = () => {
  const navigate = useNavigate()
  const { t } = useCommonTranslation()
  const setFocus = useSetFocus()

  useEffect(() => {
    setFocus(focusId)
  }, [])

  return (
    <LogoutWrapper
      orientation={orientation.HORIZONTAL}
      defaultFocusChild={0}
      focusId={focusId}
    >
      <LoginHeader showLogo={true} title={t('exitApp')} />
      <ContentBox>
        <div>
          <ImportantBodyText>{t('aboutClosing1')}</ImportantBodyText>
          <ImportantBodyText>{t('aboutClosing2')}</ImportantBodyText>
        </div>
        <ButtonBox>
          <Button
            iconSrc={icons.navigation.backArrow}
            focusId="go_Back_Button"
            text={t('goBack')}
            onClick={() => navigate(-1)}
          />
          <Button
            focusId="section_2"
            iconSrc={icons.navigation.exit}
            text={t('leaveApp')}
            onClick={closeApp}
          />
        </ButtonBox>
      </ContentBox>
      <ContentWrapper>
        <MobileApp>
          <MobileAppImgWrapper>
            <MobileAppImg src={icons.welcome.mobileAppImage} alt="" />
          </MobileAppImgWrapper>
          <MobileAppDescription>
            <TextElem>{t('availableForPhone')}</TextElem>
            <Row>
              <QrCode qrPath={qrCodeUrl} qrSize={qrSize} />
              <StoreImg src={icons.welcome.appStoreImage} alt="" />
              <StoreImg src={icons.welcome.googlePlayImage} alt="" />
            </Row>
          </MobileAppDescription>
        </MobileApp>
      </ContentWrapper>
    </LogoutWrapper>
  )
}

export const ExitScreen = memo(ExitScreenRaw)
